import { useMutation, useQueryClient } from "react-query";
import { gql } from "graphql-request";
import { IRegistrationPolicy } from "@pbm/registration-policies/contracts";
import { usePbm2Url } from "@common/hooks";

export function useUpdateRegistrationPolicy() {
  const queryClient = useQueryClient();
  const { request } = usePbm2Url();
  return useMutation(async (input: any) => {
    const { Rules_updateRegistrationPolicy } = await request(
      gql`
        mutation ($input: Rules_UpdateRegistrationPolicyInput!) {
          Rules_updateRegistrationPolicy(input: $input) {
            id
          }
        }
      `,
      { input }
    );
    queryClient.invalidateQueries(`registrationPolicy:${input.id}`);
    return Rules_updateRegistrationPolicy as IRegistrationPolicy;
  });
}
